// extracted by mini-css-extract-plugin
export default {"cards":"samvedna_cards__3kkrP"};